import { Controller } from "@hotwired/stimulus"

// Marketing fly-in: reveals descendants tagged .mkt-reveal as they scroll in.
// Also toggles the topbar's scrolled state. Respects reduced-motion.
export default class extends Controller {
  static targets = ["topbar"]

  connect() {
    this.reveals = Array.from(this.element.querySelectorAll(".mkt-reveal"))
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (reduce) { this.reveals.forEach(el => el.classList.add("in")); }
    else {
      this.io = new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); this.io.unobserve(e.target) } })
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" })
      this.reveals.forEach(el => this.io.observe(el))
    }
    this.onScroll = () => { if (this.hasTopbarTarget) this.topbarTarget.classList.toggle("scrolled", window.scrollY > 24) }
    this.onScroll(); window.addEventListener("scroll", this.onScroll, { passive: true })
  }

  disconnect() {
    if (this.io) this.io.disconnect()
    this.element.removeAttribute("data-reveal-ready")
    this.reveals.forEach(el => el.classList.remove("in"))
    window.removeEventListener("scroll", this.onScroll)
  }
}
